import React from "react";
import "../styles/BlogStyles/BlogStyles.css";
import bloglist from "../assets/blog2.jpeg";


const BlogPostDetail2 = () => {
  return (
    <article className="blog-detail-section py-5 bg-light">
      <div className="container bg-white p-0 rounded shadow-sm overflow-hidden content-container">
        
        {/* --- 1. Top Hero Image (Requested) --- */}
        <div className="w-100">
          <img
            src={bloglist}
            alt="Students Studying Roadmap"
            className="img-fluid w-100 object-fit-cover"
            style={{ maxHeight: "450px" }} 
          />
        </div>

        <div className="p-4 p-lg-5">
          {/* --- 2. Main Title --- */}
          <div className="mb-4">
            <h1 className="fw-bold text-purple display-6 mb-3">
              Your Roadmap to Success in CA, CMA & CS
            </h1>
          </div>

          {/* --- 3. Introduction --- */}
          <div className="blog-content text-secondary">
            <p className="mb-4 lead fs-6">
              If you are aspiring to become a <strong>Chartered Accountant (CA)</strong>, <strong>Cost & Management Accountant (CMA)</strong>, or <strong>Company Secretary (CS)</strong>, you've already chosen a path that leads to some of the most respected and rewarding careers in India's finance and corporate world. But let's be honest—this journey is not easy. It requires discipline, guidance, and the right strategy.
            </p>
            <p className="mb-5">
              At <strong>Madhi Academy</strong>, we believe success is not just about passing exams—it's about building a strong foundation for a thriving career. Here's a clear roadmap to help you navigate your professional journey:
            </p>

            {/* --- Point 1 --- */}
            <h4 className="fw-bold text-purple mb-3">1. Understand Your Course & Its Stages</h4>
            <p className="mb-2">Each professional qualification has multiple levels:</p>
            <ul className="mb-4 list-unstyled custom-list">
              <li><strong>CA</strong> → Foundation → Intermediate → Final</li>
              <li><strong>CMA</strong> → Foundation → Intermediate → Final</li>
              <li><strong>CS</strong> → Executive → Professional</li>
            </ul>
            <p className="mb-5 fst-italic text-muted border-start border-4 border-warning ps-3">
              👉 Before diving in, get familiar with the syllabus, exam structure, and timelines. This clarity will help you set realistic goals.
            </p>

            {/* --- Point 2 --- */}
            <h4 className="fw-bold text-purple mb-3">2. Build a Smart Study Plan</h4>
            <p className="mb-2">Time management is key. Divide your preparation into:</p>
            <ul className="mb-4 list-unstyled custom-list">
              <li><strong>Concept Learning</strong> – Build a strong base with expert guidance.</li>
              <li><strong>Practice & Revision</strong> – Regularly solve problems and revise topics.</li>
              <li><strong>Mock Exams</strong> – Simulate exam conditions to boost confidence.</li>
            </ul>
            <p className="mb-5 fst-italic text-muted border-start border-4 border-danger ps-3">
              📌 Tip: Daily consistent study always beats last-minute cramming.
            </p>

            {/* --- Point 3 --- */}
            <h4 className="fw-bold text-purple mb-3">3. Use the Right Learning Approach</h4>
            <p className="mb-2">At Madhi Academy, we follow a <strong>blended method</strong>:</p>
            <ul className="mb-5 list-unstyled custom-list">
              <li><strong>Recorded Classes</strong> for flexible, anytime learning.</li>
              <li><strong>Live Doubt Sessions</strong> for instant clarity.</li>
              <li><strong>Personal/Small Group Tuition</strong> for focused attention.</li>
              <li><strong>Test Series & Mock Exams</strong> to ensure readiness.</li>
            </ul>
            <p className="mb-5">This balance helps students manage complex subjects with ease.</p>

            {/* --- Point 4 --- */}
            <h4 className="fw-bold text-purple mb-3">4. Stay Updated with Exam Notifications</h4>
            <p className="mb-2">Exam dates, syllabus updates, and guidelines often change. Missing an update can cost you an attempt. That's why our blog regularly shares:</p>
            <ul className="mb-5 list-unstyled custom-list">
              <li>ICAI, ICMAI & ICSI announcements</li>
              <li>Exam schedules & application deadlines</li>
              <li>Syllabus changes & important updates</li>
            </ul>

            {/* --- Point 5 --- */}
            <h4 className="fw-bold text-purple mb-3">5. Focus on Practical Knowledge Too</h4>
            <p className="mb-2">Exams are just the beginning. Employers look for professionals who can apply concepts in real life.</p>
            <ul className="mb-4 list-unstyled custom-list">
              <li><strong>For CA:</strong> Focus on auditing, taxation, and financial reporting.</li>
              <li><strong>For CMA:</strong> Strengthen cost analysis, strategy, and decision-making.</li>
              <li><strong>For CS:</strong> Develop expertise in corporate governance and compliance.</li>
            </ul>
            <p className="mb-5">
              At Madhi Academy, we train students with <strong>real-world case studies</strong> so they can transition smoothly from classrooms to careers.
            </p>

            {/* --- Point 6 --- */}
            <h4 className="fw-bold text-purple mb-3">6. Stay Motivated & Consistent</h4>
            <p className="mb-2">There will be challenges—difficult topics, exam pressure, and sometimes even failures. But remember:</p>
            <ul className="mb-5 list-unstyled custom-list">
              <li><strong>Success is about persistence.</strong></li>
              <li><strong>Failures are stepping stones, not roadblocks.</strong></li>
              <li><strong>Consistency beats talent when talent isn't consistent.</strong></li>
            </ul>

            {/* --- Final Thoughts --- */}
            <div className="bg-light p-4 rounded mb-5">
              <h4 className="fw-bold text-purple mb-3">Final Thoughts</h4>
              <p className="mb-3">
                The journey to becoming a <strong>CA, CMA, or CS</strong> is demanding, but with the right support system, success is absolutely achievable. At <strong>Madhi Academy</strong>, our mission is to not only help students <strong>clear exams</strong> but also <strong>excel in their careers</strong> with confidence.
              </p>
              <p className="mb-0 fw-bold">
                Your professional success starts here. Stay tuned to our blog for exam updates, study tips, and career insights.
              </p>
            </div>

            {/* --- Contact Footer --- */}
            <div className="border-top pt-4">
              <ul className="list-unstyled">
                <li className="mb-2">
                  <i className="bi bi-telephone-fill text-purple me-2"></i>
                  <strong>Contact us today:</strong>{" "}
                  <a href="tel:+917708941960" className="text-decoration-none text-purple fw-bold">+91 7708941960</a>
                </li>
                <li>
                  <i className="bi bi-envelope-fill text-purple me-2"></i>
                  <strong>Mail Us:</strong>{" "}
                  <a href="mailto:admission@madhiacademy.com" className="text-decoration-none text-purple fw-bold">admission@madhiacademy.com</a>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </article>
  );
};

export default BlogPostDetail2;